import { endpoints, base_url } from "../Api/configs";
import apiClient, { parseResponseBody } from "./apiClient";

interface NotificationDetails {
  eventId?: string;
  message?: string;
  actionType?: string;
  type?: string;
}

const request = async (
  endpoint: string,
  method: "POST" | "PATCH",
  accessToken: string,
  body: object = {}
) => {
  return apiClient(endpoint, {
    method,
    body: JSON.stringify({ accessToken, ...body }),
    headers: { "Content-Type": "application/json" },
  });
};

export const getUserNotification = (params) =>
  request(
    endpoints.notification.getUserNotification,
    "POST",
    params.accessToken,
    {
      lastEvaluatedKey: params.lastEvaluatedKey || null,
      limit: params.limit,
      fetchTopSix: params.fetchTopSix || false, // Add fetchTopSix parameter
    }
  );

export const addUserNotification = (
  accessToken: string,
  notificationDetails: NotificationDetails
) =>
  request(endpoints.notification.addNotification, "POST", accessToken, {
    notificationDetails,
  });

export const updateNotification = (
  accessToken: string,
  notificationId: string,
  actionType: string,
  actionStatus: string
) =>
  request(endpoints.notification.updateNotification, "PATCH", accessToken, {
    notificationId,
    actionType,
    actionStatus,
  });

export const getNotificationById = (
  accessToken: string,
  notificationId: string
) =>
  request(endpoints.notification.getNotificationById, "POST", accessToken, {
    notificationId,
  });

export const getNotificationByEventId = (
  accessToken: string,
  eventId: string
) =>
  request(endpoints.notification.getEventNotification, "POST", accessToken, {
    eventId,
  });

export const markNotificationAsRead = (
  accessToken: string,
  notificationId: string
) =>
  request(endpoints.notification.markNotificationAsRead, "POST", accessToken, {
    notificationId,
  });

export const markNotificationAsSeen = (accessToken: string, category: string) =>
  request(endpoints.notification.markNotificationAsSeen, "POST", accessToken, {
    category,
  });

export const markNotificationAsSeenById = (accessToken: string, notificationId: string) =>
  request(endpoints.notification.markNotificationAsSeen, "POST", accessToken, {
    notificationId,
  });

export const sendNotificationInvite = (accessToken: string, eventId: string) =>
  request(
    endpoints.notification.InviteChallengeNotification,
    "POST",
    accessToken,
    {
      eventId,
    }
  );

export const AcceptEventChangesByOrganizer = (
  accessToken: string,
  notificationId: string,
  action: boolean
) =>
  request(endpoints.notification.AcceptEventUpdates, "POST", accessToken, {
    notificationId,
    action: action ? "accept" : "reject",
  });

export const getUnseenNotificationCounts = async (accessToken: string) => {
  try {
    const response = await fetch(
      `${base_url}${endpoints.notification.UnSeenNotificationCount}?accessToken=${encodeURIComponent(accessToken)}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    let data = await response.json();
    data = parseResponseBody(data);

    if (response.ok && data) {
      const counts = {
        organizer: data.organiser || 0,
        challenger: data.challenger || 0,
        audience: data.audience || 0,
        total: data.total || 0
      };

      return {
        statusCode: 200,
        body: counts
      };
    } else {
      return {
        statusCode: response.status || 500,
        body: {
          organizer: 0,
          challenger: 0,
          audience: 0,
          total: 0
        }
      };
    }
  } catch (error) {
    return {
      statusCode: 500,
      body: {
        organizer: 0,
        challenger: 0,
        audience: 0,
        total: 0
      }
    };
  }
};
